'use client';
import { useTranslations } from 'next-intl';
import Image from 'next/image';

export default function Hero() {
  const t = useTranslations('About');
  const title = t('title');
  const words = title.split(" ");

  return (
    <div className='mb-0 md:mb-10 mt-16 px-4 md:px-20 text-start'>
      <div className='flex flex-col md:flex-row justify-start md:items-center'>
        <h1 className='text-xl md:text-4xl lg:text-6xl leading-none text-start'>
          <span className='color-primary'>{words[0]}</span>{" "}
          {words?.slice(1).join(" ")}
        </h1>
      </div>
      <div className='mt-10'>
        <Image
          src={'/images/about/about.jpg'}
          width={4000}
          height={1000}
          alt={`Technical expertise, a creative approach, and experience to bring your projects to life`}
          className="w-full h-auto"
          style={{ objectFit: "cover", width: '100%' }}
          sizes="(max-width: 768px) 100vw, 33vw"
          quality={100}
        />
      </div>
    </div>
  );
}
